class PhotoAlbumCollection extends App.Collections.BaseCollection {
    url = 'PhotoAlbum';
    model = App.Models.PhotoAlbum;
}

App.Collections.PhotoAlbum = PhotoAlbumCollection;
